import { useContext } from "react";
import { APIErrorContext, ErrorContext } from "./APIErrorProvider";

export const useAPIError = (): ErrorContext => {
    const { error, addError, removeError } = useContext(APIErrorContext);
    return { error, addError, removeError };
};

export default useAPIError;
